module.exports = __webpack_public_path__ + "static/img/33-3.3c1de4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/33-3.jpg
// module id = Cd8x
// module chunks = 0